import { useDocumentTitle } from "../../hooks";
import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux";
import MenuItem from "../../components/admin/menu/MenuItem";
import { getPositionTopPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import BackendLayout from "../../layouts/BackendLayout";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import {POSITION_MASTER_DASHBOARD} from '../../constants/routes';
import {PageTitle} from '../../components/admin';
import {clearPageLoading, setPageLoading} from "../../store/actions";
import {errorStatusHandle} from "../../utils";
import {POSITION_MASTER_DASHBOARD_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {RedirectAlert} from "../../components";

const PositionTopPage = () => {
  useRedirectPage(POSITION_MASTER_DASHBOARD_PAGE);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  useDocumentTitle("職位マスタトップ - 点検王");
  const breadcrumb = getRouteBreadcrumb(POSITION_MASTER_DASHBOARD);

  //Function help to set page settings
  const setPositionTopPageSettings = async (e) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getPositionTopPageSettings();
      dispatch(setPageSettings(pageSettings));
      setMenuItems(pageSettings.menu_items);
    } catch (e) {
      errorStatusHandle(e)
    } finally {
      dispatch(clearPageLoading());
    }
  };

  useEffect(() => {
    setPositionTopPageSettings();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="職位マスタトップ"/>
      <RedirectAlert />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-8 py-[20px] max-w-[1160px]">
        {menuItems.map((item, index) => (
            <MenuItem key={index} menu={item.name} feature="position" />
        ))}
      </div>
    </BackendLayout>
  );
};

export default PositionTopPage;


